import { toast } from 'react-toastify';

import config from '../config';

const { appEnv } = config;

export const isProduction = () => {
  return appEnv === 'production';
};

export const getBpWidth = (prefix: 'sm' | 'md' | 'lg' | 'xl' | '2xl') => {
  switch (prefix) {
    case 'sm':
      return 640;
    case 'md':
      return 768;
    case 'lg':
      return 1024;
    case 'xl':
      return 1280;
    case '2xl':
      return 1536;
    default:
      return 0;
  }
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const sortByValue = (
  array: any[],
  value: string,
  isDescending?: boolean,
) => {
  return array.sort((one: any, other: any) => {
    if (new Date(other[value]) > new Date(one[value]))
      return isDescending ? 1 : -1;
    return isDescending ? -1 : 1;
  });
};

export const handleCopy = (
  text: string,
  setIsCopied?: (copied: boolean) => void,
  id?: string,
) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success('Copied to clipboard!', {
        toastId: `copy-success${id ? `-${id}` : ''}`,
      });

      if (setIsCopied) {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 8000);
      }
    })
    .catch((error) => {
      console.error('Failed to copy:', error);
    });
};

export const getGALabel = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1).replace(/-/g, ' ');
};

export const getRandomPercent = (minP: number, maxP: number) => {
  const min = minP / 100;
  const max = maxP / 100;

  return min + Math.random() * (max - min);
};
